// extracted by mini-css-extract-plugin
export default {"root":"Customer_root__iuzOD","menu-icon":"Customer_menu-icon__ugrkY"};